
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type AddLoadPayload = {
  stopId: EntityId | null
}

export const addLoad = createAsyncThunk<void, AddLoadPayload, { state: RootState }>(
  'shiftTable/addLoad',
  async ({ stopId }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/createLoad' : '/runsheet/createLoad'

    await OLMSApiService.post<null>(endpoint, {
      stopId: stopId,
    })
  },
)
